import { clsx } from 'clsx';
import { Checkbox } from '../../../../checkbox/Checkbox';
import { Tooltip } from '../../../../tooltip/Tooltip';
import { Icon } from '../../../../icon/Icon';

import { ObjectFieldColumnConfig } from '../../interfaces/object-field-header';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { PipelineObjectConfigTrackers } from '../../../tracking/pipeline-object-config-trackers';
import { Integration } from '../../../../shared/interfaces/integration';

export interface FieldHeaderCellProps {
  pipeline: Integration;
  columnConfig: ObjectFieldColumnConfig;
  index: number;
  selectedCount: number;
  totalCount: number;
  isViewMode?: boolean;
  isListIndeterminate: boolean;
  isListIncluded: boolean;
  changeSelectAllCheckedState: (included: boolean) => void;
}

export function FieldHeaderCell({
  pipeline,
  columnConfig,
  index,
  selectedCount,
  totalCount,
  isViewMode,
  isListIncluded,
  isListIndeterminate,
  changeSelectAllCheckedState
}: FieldHeaderCellProps) {
  const { eventTrack } = useAnalyticsTracker();

  return (
    <div className={clsx('center-flex-row w-100', index > 1 && 'justify-center')}>
      {index === 0 ? (
        <Checkbox
          dataId='all'
          name='fieldSelector'
          value='all-field-selector'
          className='mr-2'
          disabled={isViewMode}
          checked={isListIncluded}
          indeterminate={isListIndeterminate}
          onChange={() => {
            eventTrack({
              action:
                PipelineObjectConfigTrackers.PIPELINE_TRACKER_PIPELINE_OBJECT_CONFIG_FIELDS_ALL_SELECT_CLICK,
              properties: {
                pipelineId: pipeline.id,
                isListIncluded: !isListIncluded
              }
            });

            changeSelectAllCheckedState(!isListIncluded);
          }}
        />
      ) : null}

      {columnConfig.displayName}

      {index === 0 ? ` (${selectedCount} of ${totalCount})` : ''}

      <Tooltip dataId='' title={columnConfig.description}>
        <span className='ml-1 cursor-help center-flex-row'>
          <Icon name='help' size={1} />
        </span>
      </Tooltip>
    </div>
  );
}
